var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.039,
    height: 22.039,
    viewBox: "0 0 22.039 22.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16197",
    "data-name": "Path 16197",
    d: "M11.02,22.039a11.02,11.02,0,1,1,11.02-11.02A11.032,11.032,0,0,1,11.02,22.039Zm0-20.662a9.642,9.642,0,1,0,9.642,9.642A9.653,9.653,0,0,0,11.02,1.377Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16198",
    "data-name": "Path 16198",
    d: "M14.755,17.51a2.755,2.755,0,1,1,2.755-2.755A2.758,2.758,0,0,1,14.755,17.51Zm0-4.132a1.377,1.377,0,1,0,1.377,1.377A1.379,1.379,0,0,0,14.755,13.377Z",
    transform: "translate(-3.735 -3.735)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16199",
    "data-name": "Path 16199",
    d: "M12.576,20.152A7.576,7.576,0,1,1,12.576,5a7.494,7.494,0,0,1,4.547,1.523.689.689,0,0,1-.83,1.1,6.124,6.124,0,0,0-3.717-1.245,6.2,6.2,0,1,0,6.2,6.2,6.127,6.127,0,0,0-1.245-3.718.688.688,0,1,1,1.1-.829,7.49,7.49,0,0,1,1.523,4.547,7.585,7.585,0,0,1-7.576,7.576Z",
    transform: "translate(-1.556 -1.556)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16200",
    "data-name": "Path 16200",
    d: "M15.689,4.821A.689.689,0,0,1,15,4.132V.689a.689.689,0,1,1,1.377,0V4.132A.689.689,0,0,1,15.689,4.821Z",
    transform: "translate(-4.669)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16201",
    "data-name": "Path 16201",
    d: "M15.689,29.821A.689.689,0,0,1,15,29.132V25.689a.689.689,0,1,1,1.377,0v3.444A.689.689,0,0,1,15.689,29.821Z",
    transform: "translate(-4.669 -7.782)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16202",
    "data-name": "Path 16202",
    d: "M29.132,16.377H25.689a.689.689,0,1,1,0-1.377h3.444a.689.689,0,1,1,0,1.377Z",
    transform: "translate(-7.782 -4.669)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16203",
    "data-name": "Path 16203",
    d: "M17.952,12.976a.689.689,0,0,1-.421-1.234L20.764,9.25,21,8.081l-1.169.234-2.492,3.234a.689.689,0,0,1-1.091-.841L18.9,7.27a.689.689,0,0,1,.41-.255l2.435-.487a.689.689,0,0,1,.81.81l-.487,2.435a.687.687,0,0,1-.255.41l-3.438,2.649a.685.685,0,0,1-.42.143Z",
    transform: "translate(-5.013 -2.028)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.4cbc1bfd25e41c4f1e029d0ee72a9e0d.svg";
export { ForwardRef as ReactComponent };